export const DROPPABLE_TARGET_TYPE = {
  FILE_IN_FOLDER: 'FILE_IN_FOLDER',
  FOLDER_IN_FOLDER: 'FOLDER_IN_FOLDER',
  SYSTEM_IN_FOLDER: 'SYSTEM_IN_FOLDER',
} as const;
